import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bottomcards',
  templateUrl: './bottomcards.component.html',
  styleUrls: ['./bottomcards.component.css']
})
export class BottomcardsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
